import hasValidationErrors from 'components/connectedForm/utils/hasValidationErrors';
import { createBackgroundJob } from 'utils/BackgroundJobs';
import { Payment } from 'graphql/entities';
import { getMutationProps } from './DocumentAction';
import { onDocumentComplete } from '../../utils/DocumentUtils';

function onComplete(state, props, job) {
  const { overrideOutput, outputType, showSummary } = state;
  const { dispatch, onClose, onComplete, onProcessSummary, onProcessPreview } = props;

  onDocumentComplete({
    overrideOutput,
    outputType,
    documentName: 'Payment',
    dispatch,
    onClose: () => onClose(false, state, props, job),
    onComplete,
    showSummary,
    onProcessSummary: () => onProcessSummary(false, state, props, job),
    onProcessPreview,
    job,
  });
}

//NOTe - Doesn't actually generate - Just prints a single Payment.
export function generate(state, props, variables, returnUrl) {
  if (hasValidationErrors(props)) return;
  createBackgroundJob(
    Payment.print,
    getMutationProps(state, props, variables),
    props,
    returnUrl,
    'Generate Payment',
    (job) => onComplete(state, props, job)
  );
}

/**
 * Reprints a set of payments (Provided as an array within variables).
 */
export function reprintRange(state, props, variables, returnUrl) {
  if (hasValidationErrors(props)) return;
  createBackgroundJob(
    Payment.reprint,
    getMutationProps(state, props, variables, 'salesOrder'),
    props,
    null, //Don't return, stay on the Sales Order screen.
    'Generate Payment',
    (job) => onComplete(state, props, job)
  );
}
